import BaseClass from "../../util/BaseClass";
import Context from "../../context/Context";
import ClosestFacilityService from "../network/ClosestFacilityService";
import Datasets from "../datasets/Datasets";
import FacilityFootprints from "./FacilityFootprints";
import FacilityMode from "./FacilityMode";
import RouteService from "../network/RouteService";

export default class Aiim extends BaseClass {

  closestFacilityService;
  datasets;
  facilityFootprints;
  facilityMode;
  routeService;

  getCIMCategories() {
    return this.datasets && this.datasets.cimCategories;
  }

  getSource(key) {
    const categories = this.datasets && this.datasets.categories;
    if (categories) return categories.findSourceByKey(key);
  }

  getZInfo(source,feature) {
    if (this.datasets && this.datasets.levels) {
      return this.datasets.levels.getZInfo(source,feature);
    }
    return null;
  }

  load() {
    const promise = new Promise((resolve,reject) => {
      this.datasets = new Datasets();

      let nsPromise;
      if (Context.instance.appMode.isSpacePlanner()) {
        nsPromise = Promise.resolve()
      } else {
        nsPromise = this._loadNetworkServices();
      }

      this.datasets.load().then(result => {
        //console.log("after.Datasets::load",this.datasets);
        this.facilityFootprints = new FacilityFootprints();
        return this.facilityFootprints.load();
      }).then((result) => {
        this.facilityMode = new FacilityMode();
      }).then((result) => {
        if (Context.instance.appMode.isSpacePlanner()) {
          const planner = Context.instance.spaceplanner.planner;
          return planner.load();
        }
      }).then((result) => {
        return nsPromise;
      }).then((result) => {
        console.log("Aiim::load....................");
        resolve();
      }).catch(ex => {
        reject(ex);
      });

    });
    return promise;
  }

  _loadNetworkServices() {
    const promise = new Promise((resolve,reject) => {
      const promises = [];
      this.routeService = new RouteService();
      this.closestFacilityService = new ClosestFacilityService();
      promises.push(this.routeService.load());
      promises.push(this.closestFacilityService.load());
      // no catch,
      // routeService.load() and closestFacilityService.load should not reject
      Promise.all(promises).then(list => {
        //console.log("this.routeService",this.routeService);
        //console.log("this.closestFacilityService",this.closestFacilityService);
        resolve();
      });
    });
    return promise;
  }

  reset() {
    if (this.facilityFootprints) {
      this.facilityFootprints.destroy();
      this.facilityFootprints = null;
    }
    if (this.facilityMode) {
      this.facilityMode.destroy();
      this.facilityMode = null;
    }
    if (this.datasets) {
      this.datasets.destroy();
      this.datasets = null;
    }
  }

  useCIMCategories() {
    const cimCategories = this.datasets && this.datasets.cimCategories;
    return cimCategories && cimCategories.hasData();
  }

}
